import { Component, EventEmitter, Input, NgModule, OnInit, Output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import myLocaleIt from '@angular/common/locales/it';
import myLocaleFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
registerLocaleData(myLocaleIt);registerLocaleData(myLocaleFr);
import moment from 'moment';

@Component({
  selector: 'upsc-calendar-month-scroller',
  templateUrl: './calendar-month-scroller.component.html',
  styleUrls: ['./calendar-month-scroller.component.scss'],
})
export class CalendarMonthScrollerComponent implements OnInit {
  @Input() monthCount = 3;
  @Output() monthSelected: EventEmitter<string> = new EventEmitter<string>();

  public months = [];
  public isShowAll = false;
  public sessionLanguage : string;
  constructor(private translationService: TranslateService) {
    this.translationService.onLangChange.subscribe((event) => {
      this.sessionLanguage = event.lang;
      this.generateMonths();
    });
  }

  public ngOnInit() {
    this.sessionLanguage = sessionStorage.getItem('lang');
    this.generateMonths();    
  }

  private generateMonths() {
    this.months = [];
    let currentMonth = moment().locale(this.sessionLanguage).startOf('month');
    for (let i = 0; i < this.monthCount; i = i + 1) {
      this.months.push({
        text: currentMonth.format('MMM\'YY'),
        value: currentMonth.format('YYYY-MM-DD'),
      });

      currentMonth = currentMonth.add(1, 'months');
    }

    if (!this.isShowAll && this.months.length) {
      this.selectMonth(null, this.months[0]);
    }
  }

  public showAllEvents(event) {
    event.preventDefault();

    this.months.map(
      (month) => {
        month.isActive = false;
        return month;
      },
    );

    this.isShowAll = true;
    this.monthSelected.emit('all');
  }

  public selectMonth(event, dateItem: any) {
    if (event) {
      event.preventDefault();
    }

    this.months.map(
      (month) => {
        month.isActive = false;
        return month;
      },
    );

    this.isShowAll = false;
    dateItem.isActive = true;

    this.monthSelected.emit(dateItem.value);
  }
  
}
